import { loadCSRFFromMetaTag } from "@bleu.builders/ui";
import React, { useState } from "react";

export const fetcher = async (
  path: string | URL,
  options: RequestInit = {},
) => {
  const config = {
    method: "GET",
    ...options,
    headers: new Headers({
      "X-CSRF-Token": loadCSRFFromMetaTag(),
      "Content-Type": "application/pdf",
      Accept: "application/pdf",
      ...options.headers,
    }),
  };

  return fetch(path, config);
};

export const useDownloadFile = ({
  path,
  filename,
  contentType = "application/pdf",
  onDone = () => {},
  onError = () => {},
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState(false);

  const download = async () => {
    setIsDownloading(true);
    try {
      const response = await fetcher(path, {
        headers: {
          Accept: contentType,
        },
      });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("target", "_blank");
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      setError(true);
      onError();
    } finally {
      setIsDownloading(false);
      onDone();
    }
  };

  return { download, isDownloading, error };
};
